"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _Card = _interopRequireDefault(require("@material-ui/core/Card"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _PersonAdd = _interopRequireDefault(require("@material-ui/icons/PersonAdd"));

var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));

var _Edit = _interopRequireDefault(require("@material-ui/icons/Edit"));

var _ControlPointDuplicate = _interopRequireDefault(require("@material-ui/icons/ControlPointDuplicate"));

var _notistack = require("notistack");

var _reactRouterDom = require("react-router-dom");

var _users = _interopRequireDefault(require("./users"));

var _dialog = _interopRequireDefault(require("../../dialog"));

var _selectors = require("../../../../redux/locationManager/selectors");

var _locationManager = require("../../../../redux/locationManager");

var _insertChart = _interopRequireDefault(require("../../img/insert-chart.svg"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LocationItem = function LocationItem(_ref) {
  var locationId = _ref.locationId;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showDeleteDialog = _useState2[0],
      setShowDeleteDialog = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showUnclaimDialog = _useState4[0],
      setShowUnclaimDialog = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showUsersDialog = _useState6[0],
      setShowUsersDialog = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      deleting = _useState8[0],
      setDeleting = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      duplicating = _useState10[0],
      setDuplicating = _useState10[1];

  var location = (0, _selectors.useLocationSelector)(locationId);
  var history = (0, _reactRouterDom.useHistory)();
  var dispatch = (0, _reactRedux.useDispatch)();
  var saveRef = (0, _react.useRef)(null);

  var _useSnackbar = (0, _notistack.useSnackbar)(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  var editLocation = function editLocation() {
    return history.push("/admin/".concat(locationId));
  };

  var viewReport = function viewReport() {
    return history.push("/admin/".concat(locationId, "/report"));
  };

  var onDeleteLocation = function onDeleteLocation() {
    setShowDeleteDialog(false);
    setDeleting(true);
    dispatch((0, _locationManager.deleteLocation)(locationId));
  };

  var onUnclaimLocation = function onUnclaimLocation() {
    setShowUnclaimDialog(false);
    dispatch((0, _locationManager.unclaimLocation)(location));
  };

  var onDuplicateClick = function onDuplicateClick() {
    setDuplicating(true);
    dispatch((0, _locationManager.duplicateLocation)(location, setDuplicating, history, enqueueSnackbar));
  };

  var toggleActive = function toggleActive() {
    dispatch((0, _locationManager.saveLocation)(_objectSpread(_objectSpread({}, location), {}, {
      active: !location.active
    }), function () {}, null, false, enqueueSnackbar));
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Card.default, {
    className: "location-item-card"
  }, /*#__PURE__*/_react.default.createElement("div", null, !location.active ? /*#__PURE__*/_react.default.createElement("div", {
    className: "location-item-pending"
  }, "Pending Approval") : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "location-item-top-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "location-item-top-row-info"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "location-item-name"
  }, location.name), /*#__PURE__*/_react.default.createElement("div", {
    className: "location-item-address"
  }, /*#__PURE__*/_react.default.createElement("div", null, location.address.line1), /*#__PURE__*/_react.default.createElement("div", null, location.address.city, ", ", location.address.stateCode, " ", location.address.zip)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "location-item-hr"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "location-item-actions"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex center"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "text",
    onClick: editLocation
  }, /*#__PURE__*/_react.default.createElement(_Edit.default, {
    className: "marginRight5"
  }), " Edit"), deleting ? /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    size: 30
  }) : /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "text",
    onClick: function onClick() {
      return setShowDeleteDialog(true);
    }
  }, /*#__PURE__*/_react.default.createElement(_Delete.default, {
    className: "marginRight5"
  }), " Remove")), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "text",
    onClick: viewReport
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _insertChart.default,
    alt: "Show Location Report",
    className: "marginRight5"
  }), "Location Report")), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "text",
    onClick: function onClick() {
      return setShowUsersDialog(true);
    }
  }, /*#__PURE__*/_react.default.createElement(_PersonAdd.default, {
    className: "marginRight5"
  }), "Users")), /*#__PURE__*/_react.default.createElement("div", null, duplicating ? /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    size: 30
  }) : /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "text",
    onClick: onDuplicateClick
  }, /*#__PURE__*/_react.default.createElement(_ControlPointDuplicate.default, {
    className: "marginRight5"
  }), "Copy"))))), /*#__PURE__*/_react.default.createElement(_dialog.default, {
    open: showDeleteDialog,
    onClose: function onClose() {
      return setShowDeleteDialog(false);
    },
    actions: [{
      label: 'Cancel',
      onClick: function onClick() {
        return setShowDeleteDialog(false);
      }
    }, {
      label: 'Delete',
      onClick: onDeleteLocation
    }],
    title: "Confirm Delete"
  }, "Are you sure you want to delete ", location.name, "?"), /*#__PURE__*/_react.default.createElement(_dialog.default, {
    open: showUnclaimDialog,
    onClose: function onClose() {
      return setShowUnclaimDialog(false);
    },
    actions: [{
      label: 'Cancel',
      onClick: function onClick() {
        return setShowUnclaimDialog(false);
      }
    }, {
      label: 'Unclaim',
      onClick: onUnclaimLocation
    }],
    title: "Confirm Unclaim"
  }, "You are about to unlink the Organization tied to this Location. Are you sure you want to proceed?"), /*#__PURE__*/_react.default.createElement(_dialog.default, {
    open: showUsersDialog,
    onClose: function onClose() {
      return setShowUsersDialog(false);
    },
    actions: [{
      label: 'Cancel',
      onClick: function onClick() {
        return setShowUsersDialog(false);
      }
    }, {
      label: 'Save',
      onClick: function onClick() {
        return saveRef.current.click();
      }
    }],
    title: "Manage Users"
  }, /*#__PURE__*/_react.default.createElement(_users.default, {
    locationId: locationId,
    saveRef: saveRef,
    onClose: function onClose() {
      return setShowUsersDialog(false);
    }
  })));
};

var _default = LocationItem;
exports.default = _default;